module.exports = __webpack_public_path__ + "img/chart.396cca1e.png";